<i18n>
{
  "fr": {
    "tool-title": "Chronique de mesures",
    "no-data-title": "Aucune donnée",
    "parameter-type": "Paramètre mesuré",
    "data-source": "Source de données",
    "dateFrom": "Début",
    "dateTo": "Fin"
  },
  "de": {

  }
}
</i18n>

<template>
  <div class="tool" id="observation-point-time-series">
    <md-content class="md-scrollbar main-container">
      <md-empty-state
        v-if="nodata"
        class="empty-data"
        md-rounded
        md-icon="graphic_eq"
        :md-label="$t('no-data-title')"
        :md-size="170"
      >
      </md-empty-state>

      <div class="container graphs">
        <div v-if="!loading">
          <GroundwaterLevel
            v-if="hasLevel && observationPoint.type === 'W'"
            :observationPoint="observationPoint"
            @mouse-hover="onMouseHover"
            @mouse-out="onMouseOut"
            :highlightedTimestamp="highlightedTimestamp"
            :showLegends="false"
            :isXaxisVisible="true"
            :selectedValue="selectedValue"
            :showThreshold="canShowThreshold"
            :showThresholdLabel="canShowThreshold"
          />
          <MountainSpringLevel
            v-if="hasSpringLevel && observationPoint.type === 'S'"
            :observationPoint="observationPoint"
            @mouse-hover="onMouseHover"
            @mouse-out="onMouseOut"
            :highlightedTimestamp="highlightedTimestamp"
            :showLegends="false"
            :isXaxisVisible="true"
            :selectedValue="selectedValue"
            :showThreshold="canShowThreshold"
            :showThresholdLabel="canShowThreshold"
          />
          <GroundwaterTemp
            v-if="hasTemp"
            :observationPoint="observationPoint"
            @mouse-hover="onMouseHover"
            @mouse-out="onMouseOut"
            :highlightedTimestamp="highlightedTimestamp"
            :showLegends="false"
            :isXaxisVisible="true"
            :selectedValue="selectedValue"
          />
          <GroundwaterEc
            v-if="hasEc"
            :observationPoint="observationPoint"
            @mouse-hover="onMouseHover"
            @mouse-out="onMouseOut"
            :highlightedTimestamp="highlightedTimestamp"
            :showLegends="false"
            :isXaxisVisible="true"
            :selectedValue="selectedValue"
          />
        </div>
      </div>

      <div class="loading" v-if="loading">
        <md-progress-spinner class="loading-animation" :md-diameter="100" :md-stroke="5" md-mode="indeterminate"></md-progress-spinner>
      </div>
    </md-content>
  </div>
</template>


<script>

import _ from 'lodash'

import AccessToken from '@/utils/accessToken'
import ObservationPointProxy from '@/proxies/observationPoint'
import GroundwaterLevel from '@/components/timeseries/graphs/groundwaterLevel'
import MountainSpringLevel from '@/components/timeseries/graphs/mountainSpringLevel'
import GroundwaterTemp from '@/components/timeseries/graphs/groundwaterTemp'
import GroundwaterEc from '@/components/timeseries/graphs/groundwaterEc'

export default {
  name: 'ObservationPointTimeSeries',
  components: {
    GroundwaterLevel,
    GroundwaterTemp,
    GroundwaterEc,
    MountainSpringLevel
  },
  props: {
    observationPointId: {
      type: Number,
      default: 0
    },
    highlightedTimestamp: {
      type: String,
      default: null
    },
    selectedValue: {
      type: String,
      default: 'avgValue'
    }
  },
  data () {
    return  {
      loading: true,
      observationPoint : {}
    }
  },
  computed: {
    datasources () {
      return this.observationPoint.datasources
    },
    nodata () {
      return !this.loading && _.isEmpty(this.observationPoint)
    },
    hasLevel () {
      return this.datasources.filter((ds) => { return ds.parameterType.code === 'HEAD_BSL' || ds.parameterType.code === 'HEAD_SFL' }).length > 0
    },
    hasSpringLevel () {
      return this.datasources.filter((ds) => { return ds.parameterType.code === 'WATER_LEVEL' }).length > 0
    },  
    hasTemp () {
      return this.datasources.filter((ds) => { return ds.parameterType.code === 'TEMP' }).length > 0
    },
    hasEc () {
      return this.datasources.filter((ds) => { return ds.parameterType.code === 'EC' }).length > 0
    },
    canShowThreshold () {
      return AccessToken.get().hasRight('strates_des')
    }
  },
  watch: {
    dateFrom () {
      if (this.datasources.length > 0) this.updateData()
    }
  },
  mounted () {
    this.loading = true
    this.load().finally(() => this.loading = false)
  },
  methods: {
    load () {
      return new Promise((resolve, reject) => {
        ObservationPointProxy.get(this.observationPointId).then((observationPoint) => {
          this.observationPoint = observationPoint
          resolve()
        }).catch(reject)
      })
    },
    onMouseHover () {
      // this.highlightedTimestamp = event.x
    },
    onMouseOut () {
      // this.highlightedTimestamp = null
    }
  }
}
</script>

<style lang="scss">
  #observation-point-time-series {
    .data-graph {
      margin: 20px;
      height: 220px;

      & .plotly {
        height: 220px;
        width: 100%;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .container.graphs {
    padding-left: 100px;
  }
</style>
